import classes from './AboutSection.module.scss';

const AboutSection = () => {

  return (
    <section name="about" className={`${classes['about-section']} pg-page`} id="about">
      <div className="container">
        <div className={classes['about']}>
          <h2 className='section-title red'>About Me</h2>
          <h2 className={classes['subtitle']}>I am a full-stack developer working from home.</h2>
          <p>I've been a fullstack web developer for about 10 years now, having worked in the Philippines and Singapore. I've also recently worked remotely with a company in Hong Kong.</p>
          <p>I love building up beautifully designed web applications and I enjoy building both the UI as well as how the site works under the hood. Having worked with mostly agencies, it has also given me insight on the inner workings of rapidly building out websites, from design to methodology, to managing timelines and pipelines, and a lot more that I can offer beyond the programming aspect.</p>
          <p>I'm also an amateur astronomer, having just rekindled my passion for Astronomy and the cosmos. I also have a love for Chess and play on occassion.</p>
        </div>
        <div className={`${classes['about']} flow`}>
          <div>
            <h2 className="red">Front-end Development</h2>
            <p>I have deep experience in building web applications on the frontend side. I always aim to deliver projects that are semantic, accessible & compliant with industry standards like WCAG.</p>
          </div>
          <div>
            <h2 className="red">Back-end Development</h2>
            <p>I've also been a backend developer using PHP, from vanilla PHP to CMSes like WordPress, Craft and frameworks like Laravel. With it comes required tools like SQL, servers like Apache or NGINX & different OS like Linux & Ubuntu.</p>
          </div>
          <div>
            <h2 className="red">UI/UX Consultant</h2>
            <p>Being a fullstack developer means I'm able to give insight and recommendations on various projects, from different approaches to strategies, whether it be on the design or development stages.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection;